/**
 * Created by fworld on 2019/10/8.
 */
import request from '@/util/request'

export const logoCreate = (data) => {
    return request({
        'url': '/api/v1/delivery/logo/create',
        'method': 'post',
        data
    })
}

export const logoUpdate = (data) => {
    return request({
        'url': '/api/v1/delivery/logo/update',
        'method': 'post',
        data
    })
}

export const logoList = () => {
    return request({
        'url': '/api/v1/delivery/logo/list',
        'method': 'get',
    })
}

export const logoDeviceUnion = (params) => {
    return request({
        'url': '/api/v1/delivery/logo/device/union',
        'method': 'get',
        params
    })
}

export const logoDeviceList = (params) => {
    return request({
        'url': '/api/v1/delivery/logo/device/list',
        'method': 'get',
        params
    })
}

export const logoDeviceBind = (data) => {
    return request({
        'url': '/api/v1/delivery/logo/device/bind',
        'method': 'post',
        data
    })
}

export const logoDeviceUnBind = (params) => {
    return request({
        'url': '/api/v1/delivery/logo/device/unbind',
        'method': 'get',
        params
    })
}
